import { createRequest } from "helpers/tools";

export const sendFreshSalesData = async (data) => {
    return await createRequest({
        suffix: "freshsales",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const freshSalesMapping = async (data, id) => {
    return await createRequest({
        suffix: `freshsales/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getFreshSalesMapping = async (id) => {
    return await createRequest({
        suffix: `freshsales/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getFreshSalesTest = async (id) => {
    return await createRequest({
        suffix: `freshsales/${id}/preview`,
        method: "get",
        handleError: false,
    });
};
